import { useContext, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { SplitioContext, SplitioFeature } from 'components/SplitioContext';

const useCachedCMSDataTreatment = () => {
  const { features } = useSelector((state: any) => state.eventConfigs);
  const useCachedCMSData = useMemo(() => features.includes('useCachedCMSData'), [features]);
  const { isReady, isTreatmentOn } = useContext(SplitioContext);
  const { cachedCMSDataError } = useSelector((state: any) => state.cms.events);

  return useMemo(
    () => useCachedCMSData && isReady && isTreatmentOn(SplitioFeature.useCachedCMSData) && !cachedCMSDataError,
    [useCachedCMSData, isReady, isTreatmentOn, cachedCMSDataError],
  );
};

export default useCachedCMSDataTreatment;
